module.exports = __webpack_public_path__ + "static/media/ICONO-CARPETA-PREMIUM2.43278f5b.png";